











import Vue from "vue";

export default Vue.extend({
    name: "TabbarBase",
    data() {
        return {
            active: "home",
            iconPrefix: this.$constants.CUSTOM_ICON_PREFIX
        };
    }
});
